//
// Copyright (c) 2011-2026 by Curalate, Inc.
//

import { useRef } from 'react';

export const useSamplingCampaignSaveQueue = () => {
  const saveQueueRef = useRef<Promise<void>>();

  return <T>(save: () => Promise<T>): Promise<T> => {
    const savePromise = saveQueueRef.current
      ? saveQueueRef.current.then(save)
      : save();
    // Keep later saves runnable after a failure without hiding it from callers.
    const settled = savePromise.then(
      () => undefined,
      () => undefined,
    );
    saveQueueRef.current = settled;
    void settled.then(() => {
      if (saveQueueRef.current === settled) {
        saveQueueRef.current = undefined;
      }
    });
    return savePromise;
  };
};
